export default __webpack_public_path__ + "static/media/order-inactive.74f78dfa.svg";